export var SHOW_COPYING = 'SHOW_COPYING';
export var SHOW_COPYING_DONE = 'SHOW_COPYING_DONE';
